<div class="initiate-heading">
    <h5>Parker to Group Operator</h5>
    <img (click)="close()" src="assets/images/new-close.svg" alt="Close" />
</div>

<div class="role-text">
    <p>Provide the mandatory details for the Group Operator role.</p>
</div>
<form [formGroup]="convertUserToGroupOperatorForm" (ngSubmit)="onSubmit()">
    <div class="register-input">
        <div class="search-input company-outer">
            <label for="groupName">Company Name <span class="custom-star">*</span></label>
            <input type="text" pInputText placeholder="Enter Company Name" formControlName="groupName" maxlength="50"
                (keydown)="preventFirstSpace($event)" (keydown.enter)="onSubmit()" />
            <div class="error-outer">
                <div *ngIf="
                            convertUserToGroupOperatorForm.get('groupName')?.hasError('required') &&
                              (convertUserToGroupOperatorForm.get('groupName')?.dirty ||
                              convertUserToGroupOperatorForm.get('groupName')?.touched)
                            ">
                    <div class="validation-error">This field is required*</div>
                </div>

                <div *ngIf="
                              convertUserToGroupOperatorForm.get('groupName')?.hasError('minlength') &&
                              (convertUserToGroupOperatorForm.get('groupName')?.dirty ||
                              convertUserToGroupOperatorForm.get('groupName')?.touched)
                            ">
                    <div *ngIf="
                                !convertUserToGroupOperatorForm.get('groupName')?.hasError('leadingSpace')
                              " class="validation-error">
                        Min. 3 letters are required*
                    </div>
                </div>

                <div *ngIf="
                              convertUserToGroupOperatorForm.get('groupName')?.hasError('pattern') &&
                              (convertUserToGroupOperatorForm.get('groupName')?.dirty ||
                              convertUserToGroupOperatorForm.get('groupName')?.touched)
                            ">
                    <div class="validation-error">
                        Please enter only characters*
                    </div>
                </div>

                <div *ngIf="convertUserToGroupOperatorForm.get('groupName')?.hasError('leadingSpace')"
                    class="validation-error">
                    Company Name cannot start with a space.</div>
            </div>
        </div>

    </div>

    <div class="booking-note">
        <p><span>Note :</span> All associated data will be migrated to the updated role.</p>
    </div>
    <div class="yes-no-btn">
        <p-button type="submit" label="Continue" class="btn-continue mr-3"></p-button>
    </div>
</form>